import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyDatePickerModule } from 'mydatepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbTabsetModule, NbRouteTabsetModule, NbStepperModule, NbButtonModule, NbListModule, NbAccordionModule, NbUserModule, NbCardModule, NbIconModule, NbInputModule, NbTreeGridModule, NbSpinnerModule, NbCheckboxModule, NbSelectModule } from '@nebular/theme';


import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ThemeModule } from '../../@theme/theme.module';
import { NgxMaskModule } from 'ngx-mask';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DualListModule } from '../../shared/components/dualList/dual-list.module';
import { GestaoFuncionariosRoutingModule } from './gestao-funcionarios-routing.module';
import { GestaoFuncionariosComponent } from './gestao-funcionarios.component';
import { DemissaoFuncionariosComponent } from './demissao-funcionario/demissao-funcionarios.component';
import { CadastroFuncionarioComponent } from './funcionario/cadastro-funcionario/cadastro-funcionario.component';
import { CadastroVincularProdutoComponent } from './funcionario/vincular-produto/cadastro-vincular-produto/cadastro-vincular-produto.component';
import { ListarVinculoProdutoComponent } from './funcionario/vincular-produto/listar-vinculo-produto/listar-vinculo-produto.component';
import { ListaAlteracaoStatusComponent } from './alteracao-status/lista-alteracao-status/lista-alteracao-status.component';
import { ListaAlteracaoLimiteComponent } from './alteracao-limite/lista-alteracao-limite/lista-alteracao-limite.component';
import { ListaFuncionarioComponent } from './funcionario/lista-funcionario/lista-funcionario.component';
import { ImportacaoFuncionariosComponent } from './funcionario/importacao/importacao-funcionarios/importacao-funcionarios.component';
import { ComponentstModule } from '../../shared/components/components.module';
import { ConsultaArquivosImportacaoFuncionariosComponent } from './funcionario/importacao/consulta-arquivos-importacao-funcionarios/consulta-arquivos-importacao-funcionarios.component';
import { ConsultaImportacaoFuncionariosComponent } from './funcionario/importacao/consulta-importacao-funcionarios/consulta-importacao-funcionarios.component';
import { ObservacaoImportacaoFuncionarioComponent } from './funcionario/importacao/consulta-importacao-funcionarios/observacao-importacao-funcionario/observacao-importacao-funcionario.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
import { OperacoesAgendadasComponent } from './pagamento-salario/operacoes-agendadas/operacoes-agendadas.component';
import { ModalCancelAgendamentoComponent } from './pagamento-salario/operacoes-agendadas/modal-cancel-agendamento/modal-cancel-agendamento.component';
import { ConsultarFuncionarioComponent } from './funcionario/consultar-funcionario/consultar-funcionario.component';
import { VisualizarFuncionarioComponent } from './funcionario/visualizar-funcionario/visualizar-funcionario.component';
import { ModalPrimeiraViaComponent } from './funcionario/modal-primeira-via/modal-primeira-via.component';
import { ModalEmissaoCartaoComponent } from './funcionario/importacao/importacao-funcionarios/modal-emissao-cartao/modal-emissao-cartao.component';
import { ImportarArquivoFuncionarioComponent } from './funcionario/importacao/importar-arquivo-funcionario/importar-arquivo-funcionario.component';
import { ModalImportarArquivoFuncionarioComponent } from './funcionario/importacao/importar-arquivo-funcionario/modal-importar-arquivo-funcionario/modal-importar-arquivo-funcionario.component';
import { MigrarFuncionariosComponent } from './funcionario/rollout-funcionario/pages/migrar-funcionarios/migrar-funcionarios.component';
import { AcompanharMigracoesComponent } from './funcionario/rollout-funcionario/pages/acompanhar-migracoes/acompanhar-migracoes.component';
import { ImportacaoFuncionarioLoteModule } from '../../shared/importacao-funcionario-lote/importacao-funcionario-lote.module';
import { ImportacaoLoteComponentsModule } from '../../shared/importacao-lote/importacao-lote.module';

@NgModule({
  imports: [
    CommonModule,
    GestaoFuncionariosRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NbTabsetModule,
    NbRouteTabsetModule,
    NbStepperModule,
    NbButtonModule,
    NbListModule,
    NbAccordionModule,
    NbUserModule,
    NbCardModule,
    NbIconModule,
    NbInputModule,
    NbTreeGridModule,
    Ng2SmartTableModule,
    ThemeModule,
    MyDatePickerModule,
    NgxMaskModule.forRoot(),
    NgxDatatableModule,
    NbSpinnerModule,
    DualListModule,
    ComponentstModule,
    NbCheckboxModule,
    CurrencyMaskModule,
    NgxMyDatePickerModule.forRoot(),
    ImportacaoFuncionarioLoteModule,
    NbSelectModule,
  ],
  exports: [
    MyDatePickerModule
  ],
  declarations: [
    GestaoFuncionariosComponent,
    DemissaoFuncionariosComponent,
    CadastroFuncionarioComponent,
    CadastroVincularProdutoComponent,
    ListarVinculoProdutoComponent,
    ListaAlteracaoStatusComponent,
    ListaAlteracaoLimiteComponent,
    ListarVinculoProdutoComponent,
    ListaAlteracaoStatusComponent,
    ListaFuncionarioComponent,
    ImportacaoFuncionariosComponent,
    ConsultaArquivosImportacaoFuncionariosComponent,
    ConsultaImportacaoFuncionariosComponent,
    ObservacaoImportacaoFuncionarioComponent,
    OperacoesAgendadasComponent,
    ModalCancelAgendamentoComponent,
    ConsultarFuncionarioComponent,
    VisualizarFuncionarioComponent,
    ModalPrimeiraViaComponent,
    ModalEmissaoCartaoComponent,
    ImportarArquivoFuncionarioComponent,
    ModalImportarArquivoFuncionarioComponent,
    MigrarFuncionariosComponent,
    AcompanharMigracoesComponent,
  ],
  entryComponents: [
    ObservacaoImportacaoFuncionarioComponent,
    ModalCancelAgendamentoComponent,
    ModalPrimeiraViaComponent,
    ModalEmissaoCartaoComponent,
    ModalImportarArquivoFuncionarioComponent
  ],
  providers: [
  ]
})
export class GestaoFuncionariosModule { }
